import { render, staticRenderFns } from "./QuickSettingsIcon.vue?vue&type=template&id=61a84c46&scoped=true"
import script from "./QuickSettingsIcon.vue?vue&type=script&lang=js"
export * from "./QuickSettingsIcon.vue?vue&type=script&lang=js"
import style0 from "./QuickSettingsIcon.vue?vue&type=style&index=0&id=61a84c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a84c46",
  null
  
)

export default component.exports